import { Button, ButtonVariant } from '@aus-platform/design-system';
import classNames from 'classnames';
import { QRCodeSVG } from 'qrcode.react';
import React, { useState } from 'react';
import { CopyableText } from '../../copyable-text';

type QRCodeSetupProps = {
  className?: string;
  qrCodeUrl: string;
  secretKey: string;
};

export const QRCodeSetup: React.FC<QRCodeSetupProps> = ({
  className,
  qrCodeUrl,
  secretKey,
}) => {
  // States.
  const [showSetupKey, setShowSetupKey] = useState(false);

  // Variables.
  const customClassname = classNames('qr-code-setup', className);

  // Handlers.
  const handleToggleSetupKey = () => {
    setShowSetupKey((prev) => !prev);
  };

  return (
    <div className={customClassname}>
      <div className="qr-code-setup__qr-container">
        <div className="qr-code-setup__qr-code">
          <QRCodeSVG value={qrCodeUrl} size={148} />
        </div>
      </div>

      <Button onClick={handleToggleSetupKey} variant={ButtonVariant.Link}>
        {showSetupKey ? 'Hide setup key' : "Can't scan the QR code?"}
      </Button>

      {showSetupKey && (
        <div className="qr-code-setup__setup-key">
          <h5 className="qr-code-setup__setup-key__label">Setup Key</h5>
          <p className="qr-code-setup__setup-key__description">
            If you can't scan the QR code, enter this setup key in your
            authenticator app.
          </p>
          <CopyableText
            className="qr-code-setup__setup-key__key-container"
            value={secretKey}
            iconSize={16}
          />
        </div>
      )}
    </div>
  );
};
